var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40.001,
    viewBox: "985.001 86.999 40 40.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1005 127a1.987 1.987 0 0 1-1.414-.585l-18.001-18.001a2.003 2.003 0 0 1 0-2.828l18-18.001c.379-.378.881-.586 1.415-.586s1.037.208 1.415.586l18 18c.377.379.585.881.585 1.415s-.208 1.036-.585 1.414l-18 18c-.378.378-.88.586-1.415.586Zm0-11.349a2.22 2.22 0 0 0-2.217 2.217 2.22 2.22 0 0 0 2.217 2.217 2.22 2.22 0 0 0 2.216-2.217 2.22 2.22 0 0 0-2.216-2.217Zm0-21.736c-.951 0-1.725.773-1.725 1.724v14.778c0 .95.774 1.725 1.725 1.725.95 0 1.724-.774 1.724-1.725V95.64c0-.95-.773-1.724-1.724-1.724Z",
    fill: "#fc5454",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b6677a7c652513fa33f123ca6cd8687b.svg";
export { ForwardRef as ReactComponent };